import { RDEqipOptionalForms } from '@cibo/core'
import { ResourceDetailFeature } from '@cibo/ui'
import { RDEqipOptionalFormsTaskEditor } from './RDEqipOptionalFormsTaskEditor'

export const RDEqipOptionalFormsResourceDetailFeature: ResourceDetailFeature<RDEqipOptionalForms> =
  {
    traitId: 'eqipOptionalForms',
    TaskEditor: RDEqipOptionalFormsTaskEditor,
  }
